import { useLocation, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { memo, useMemo, useState } from "react";
import { Button } from "primereact/button";

const ADMIN_SECTIONS = [
  { id: "familias", label: "Familias", icon: "pi pi-sitemap", path: "/administracion/familias" },
  { id: "sucursales", label: "Sucursales", icon: "pi pi-map-marker", path: "/administracion/sucursales" },
  { id: "usuarios", label: "Usuarios", icon: "pi pi-users", path: "/administracion/usuarios" },
  { id: "banners", label: "Banners", icon: "pi pi-images", path: "/administracion/banners" },
  { id: "destacados", label: "Destacados", icon: "pi pi-box", path: "/administracion/destacados" },
  { id: "categorias", label: "Categorías", icon: "pi pi-tags", path: "/administracion/categorias" },
  { id: "reportes", label: "Reportes", icon: "pi pi-chart-line", path: "/administracion/reportes" },
];

const AdminSidebar = memo(() => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const filteredSections = useMemo(() => {
    if (!searchTerm.trim()) return ADMIN_SECTIONS;
    const term = searchTerm.toLowerCase();
    return ADMIN_SECTIONS.filter((section) =>
      section.label.toLowerCase().includes(term)
    );
  }, [searchTerm]);

  return (
    <aside className="admin-pages-list">
      <div className="admin-pages-list-header">
        <h2 className="admin-text-lg">
          <i className="pi pi-cog" />
          Administración
        </h2>
      </div>

      <span className="p-input-icon-left admin-pages-search">
        <i className="pi pi-search" />
        <InputText
          className="admin-pages-field admin-pages-search-input admin-text-sm"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </span>

      <Button label="Volver" onClick={() => navigate("/mi-cuenta")} size="small" rounded icon="pi pi-arrow-left" />

      <div className="admin-pages-items-container" style={{ maxHeight: "calc(100vh - 320px)", overflow: "auto" }}>
        <aside className="flex flex-column gap-2">
          {filteredSections.map((section) => {
            const isActive = location.pathname === section.path;
            return (
              <div
                key={section.id}
                className={`admin-page-item ${isActive ? "active" : ""} ${section.disabled ? "p-disabled" : ""}`}
                onClick={() => !section.disabled && navigate(section.path)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") navigate(section.path);
                }}
              >
                <div className="admin-page-item-content">
                  <div className="admin-page-item-icon">
                    <i className={section.icon} />
                  </div>
                  <div className="admin-page-item-info">
                    <span className="admin-page-item-label admin-text-sm">{section.label}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </aside>
      </div>
    </aside>
  );
});

export default AdminSidebar;
